import React from "react";
import { ChevronDown } from "lucide-react";

// Common dial codes (India first). ISO2 codes used for compact chip.
export const DIAL_CODES = [
  { code: "+91", iso: "IN", name: "India" },
  { code: "+1", iso: "US", name: "United States" },
  { code: "+44", iso: "GB", name: "United Kingdom" },
  { code: "+971", iso: "AE", name: "UAE" },
  { code: "+61", iso: "AU", name: "Australia" },
  { code: "+1", iso: "CA", name: "Canada" },
  { code: "+65", iso: "SG", name: "Singapore" },
  { code: "+966", iso: "SA", name: "Saudi Arabia" },
  { code: "+974", iso: "QA", name: "Qatar" },
  { code: "+965", iso: "KW", name: "Kuwait" },
  { code: "+968", iso: "OM", name: "Oman" },
  { code: "+973", iso: "BH", name: "Bahrain" },
  { code: "+60", iso: "MY", name: "Malaysia" },
  { code: "+66", iso: "TH", name: "Thailand" },
  { code: "+62", iso: "ID", name: "Indonesia" },
  { code: "+63", iso: "PH", name: "Philippines" },
  { code: "+84", iso: "VN", name: "Vietnam" },
  { code: "+977", iso: "NP", name: "Nepal" },
  { code: "+94", iso: "LK", name: "Sri Lanka" },
  { code: "+880", iso: "BD", name: "Bangladesh" },
  { code: "+92", iso: "PK", name: "Pakistan" },
  { code: "+49", iso: "DE", name: "Germany" },
  { code: "+33", iso: "FR", name: "France" },
  { code: "+39", iso: "IT", name: "Italy" },
  { code: "+34", iso: "ES", name: "Spain" },
  { code: "+31", iso: "NL", name: "Netherlands" },
  { code: "+41", iso: "CH", name: "Switzerland" },
  { code: "+353", iso: "IE", name: "Ireland" },
  { code: "+27", iso: "ZA", name: "South Africa" },
  { code: "+254", iso: "KE", name: "Kenya" },
  { code: "+234", iso: "NG", name: "Nigeria" },
  { code: "+20", iso: "EG", name: "Egypt" },
  { code: "+64", iso: "NZ", name: "New Zealand" },
  { code: "+81", iso: "JP", name: "Japan" },
  { code: "+82", iso: "KR", name: "South Korea" },
  { code: "+86", iso: "CN", name: "China" },
  { code: "+852", iso: "HK", name: "Hong Kong" },
  { code: "+55", iso: "BR", name: "Brazil" },
  { code: "+52", iso: "MX", name: "Mexico" },
  { code: "+90", iso: "TR", name: "Turkey" },
  { code: "+972", iso: "IL", name: "Israel" },
];

export default function PhoneField({
  phone,
  onPhoneChange,
  dial,
  onDialChange,
  placeholder = "Mobile number",
  testIdPhone = "phone-input",
  testIdDial = "dial-code-select",
  maxLength = 15,
}) {
  return (
    <div className="flex items-stretch gap-2">
      <div className="relative">
        <select
          data-testid={testIdDial}
          value={`${dial.iso}-${dial.code}`}
          onChange={(e) => {
            const [iso, code] = e.target.value.split("-");
            const found = DIAL_CODES.find((d) => d.iso === iso && d.code === code);
            onDialChange(found || DIAL_CODES[0]);
          }}
          className="input-native input-native--auto pr-5 pl-2.5 w-[62px] appearance-none font-medium bg-neutral-50 cursor-pointer text-[13px]"
          aria-label="Country code"
        >
          {DIAL_CODES.map((d) => (
            <option key={`${d.iso}-${d.code}`} value={`${d.iso}-${d.code}`}>
              {d.code}
            </option>
          ))}
        </select>
        <ChevronDown className="absolute right-1 top-1/2 -translate-y-1/2 w-3 h-3 text-neutral-500 pointer-events-none" />
      </div>
      <input
        data-testid={testIdPhone}
        type="tel"
        inputMode="numeric"
        className="input-native flex-1 min-w-0"
        placeholder={placeholder}
        value={phone}
        onChange={(e) => onPhoneChange(e.target.value.replace(/\D/g, ""))}
        maxLength={maxLength}
      />
    </div>
  );
}
